import React from "react";

type Props = {
  params: any[];
};

export default function BranchesAmountView({ params }: Props) {
  return (
    <>
      {params.map((item: any) => {
        return (
          <div
            key={item.id}
            className="w-full flex flex-row justify-between"
          >
            <p className="my-0">{item.branchName}</p>
            <p className="my-0">
              {item.chargeType === "Amount"
                ? "$" + item.amountOrPercentage
                : item.amountOrPercentage + "%"}
            </p>
          </div>
        );
      })}
    </>
  );
}
